import { AxiosInstance } from 'axios';
import { CreateSubscriptionDto } from '@jaam/commons/dtos';

export interface SubscriptionResponse {
  subscription: {
    id: number;
    companyId: number;
    planId: number;
    status: string;
  };
}

export function createSubscriptionService(api: AxiosInstance) {
  return {
    create: (dto: CreateSubscriptionDto) =>
      api.post<SubscriptionResponse>('/subscriptions', dto),
  };
}
